import { render, staticRenderFns } from "./Tr.vue?vue&type=template&id=358b58a5&scoped=true&"
import script from "./Tr.vue?vue&type=script&lang=ts&"
export * from "./Tr.vue?vue&type=script&lang=ts&"
import style0 from "./Tr.vue?vue&type=style&index=0&id=358b58a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b58a5",
  null
  
)

export default component.exports